module.exports = __webpack_public_path__ + "static/img/header-img.d6d3a2f.jpeg";